export default {
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {

    async postNewUser ({getters}, user: User) {
      console.log('store.postNewUser', user)
      const api = getters.api
      const response = await api.post('users', user)
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not add new user."
        }
      }
      return response.data
    },

    async getUsers ({getters}) {
      console.log('store.getUsers')
      const api = getters.api
      const response = await api.get('users')
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not get users list."
        }
      }
      return response.data
    },

    async getAdminUsers ({getters}) {
      console.log('store.getAdminUsers')
      const api = getters.api
      const response = await api.get('admins')
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not get users list."
        }
      }
      return response.data
    },

    async getUser ({getters}, userId: number) {
      console.log('store.getUser', userId)
      const api = getters.api
      const response = await api.get('users/'+userId)
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not get user details."
        }
      }
      return response.data
    },

    async patchUser ({commit, getters}, user: User) {
      console.log('store.patchUser', user)
      const api = getters.api
      const response = await api.patch('users/'+user.id, user)
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not update user details."
        }
      }
      return response.data
    },

    async addOrUpdateUser ({getters, dispatch}, user: User) {
      console.log('store.addOrUpdateUser', user)
      if (!user) {
        return {
          success: false,
          message: 'No data'
        }
      }
      if (user.id) {
        // patch user as bank
        if (getters.sessionUserIsBank) {
          return await dispatch('patchCustomerUser', user)
        }
        // patch user as admin
        return await dispatch('patchUser', user)
      }
      // new user as bank
      if (getters.sessionUserIsBank) {
        return await dispatch('postNewCustomerUser', user)
      }
      // new user as admin
      return await dispatch('postNewUser', user)
    },

    async deleteUser ({commit, getters}, user: User) {
      console.log('store.deleteUser', user)
      const api = getters.api
      let response: any
      if (getters.sessionUserIsBank) {
        response = await api.delete('customers/'+user.customer_id+'/users/'+user.id)
      } else {
        response = await api.delete('users/'+user.id)
      }
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not deauthorize user."
        }
      }
      return response.data
    },

    async resetUserPassword ({commit, getters}, user: User) {
      console.log('store.resetUserPassword', user)
      const api = getters.api
      const response = await api.get('users/'+user.id+'/reset-pass')
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not reset user password."
        }
      }
      return response.data
    },

    async resetUserOTP ({commit, getters}, user: User) {
      console.log('store.resetUserOTP', user)
      const api = getters.api
      const response = await api.get('users/'+user.id+'/reset-otp')
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not reset user one-time password."
        }
      }
      return response.data
    },


    // Bank Users

    async getBankUsers ({commit, getters}, bankId: number) {
      console.log('store.getBankUsers', bankId)
      const currentBankId = getters.currentBankId
      if (!bankId && currentBankId) bankId = currentBankId
      const api = getters.api
      let response: any
      if (getters.sessionUserIsBank) {
        response = await api.get('users')
      } else if (bankId) {
        response = await api.get(`banks/${bankId}/users`)
      } else {
        return {
          success: false,
          message: "Missing Bank ID."
        }
      }
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not get bank users list."
        }
      }
      return response.data
    },


    // Customer Users

    async postNewCustomerUser ({getters}, user: User) {
      console.log('store.postNewCustomerUser', user)
      const api = getters.api
      let response = await api.post('customers/'+user.customer_id+'/users', user)
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not add new user."
        }
      }
      return response.data
    },

    async patchCustomerUser ({getters}, user: User) {
      console.log('store.patchCustomerUser', user)
      const api = getters.api
      let response = await api.patch('customers/'+user.customer_id+'/users/'+user.id, user)
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not update customer user."
        }
      }
      return response.data
    },

    async getCustomerUsers ({getters}, custId: number) {
      console.log('store.getCustomerUsers', custId)
      const api = getters.api
      let response: any
      if (getters.sessionUserIsBank) {
        response = await api.get('customers')
      } else if (custId) {
        response = await api.get(`banks/${custId}/users`)
      } else {
        return {
          success: false,
          message: "Missing Bank ID."
        }
      }
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not get customer users list."
        }
      }
      return response.data
    },


    // Debug

    // logState ({state}) {
    //   console.log('store.users', state)
    // }

  }
}
